// credits go to: https://stackoverflow.com/a/63176814/5346779
// +Number.EPSILON is required to correctly round numbers like this:
// roundToPrecision(1.005, 2) should return 1.01 instead of 1.
const roundToPrecision = (value: number, decimals: number) => {
  const precision = Math.pow(10, decimals);
  return Math.round((value + Number.EPSILON) * precision) / precision;
};

export default roundToPrecision;
